<template>
  <!-- 在线咨询弹窗组件 -->
  <el-dialog title="在线咨询" :visible="visible" :width="dialogWidth" append-to-body @close="closeDialog">
    <div class="online-box" v-loading="loading">
      <!-- 提示语 -->
      <p class="tips">您可以扫下方二维码,专员在线提供咨询服务!</p>

      <div class="online-content">
        <!-- 左侧：企微二维码 -->
        <div class="qrcode-box">
          <img class="qrcode" :src="qrcodeImg" alt="官方企微二维码">
        </div>

        <!-- 右侧：咨询电话 + 关闭按钮 -->
        <div class="right-box">
          <div class="phone-box">
            <div class="phone-row">
              <span class="phone-label">咨询电话：{{ contactName }}</span>
            </div>
            <div class="phone-row">
              <span class="phone-number">{{ contactPhone }}</span>
            </div>
          </div>

          <!-- 关闭按钮：蓝色边框 + 蓝色字体 -->
          <div class="btn-box">
            <el-button class="btn-close" @click="closeDialog">{{ closeText }}</el-button>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import qrcodeImg from '@/assets/images/home/qrcode.png';

export default {
  name: 'OnlineDialog', // 组件名（必填，用于注册）
  props: {
    // 弹窗是否显示（双向绑定）
    visible: {
      type: Boolean,
      default: false
    },
    // 弹窗标题（可自定义）
    dialogTitle: {
      type: String,
      default: '在线咨询'
    },
    // 弹窗宽度（可自定义）
    dialogWidth: {
      type: String,
      default: '560px'
    },
    // 关闭按钮文本（可自定义）
    closeText: {
      type: String,
      default: '我知道了'
    }
  },
  data() {
    return {
      loading: false,
      qrcodeImg: qrcodeImg,
      // 咨询联系人信息
      contactName: '岳女士',
      contactPhone: '13666648636'
    }
  },
  methods: {
    // 关闭弹窗
    closeDialog() {
      // 向父组件发送关闭事件（双向绑定同步）
      this.$emit('closeDialog');
    },
  }
};
</script>

<style scoped>
.online-box {
  padding: 0 10px;
}

/* 提示语 */
.online-box .tips {
  margin: 0 0 20px;
  font-size: 17px;
  color: rgba(0, 0, 0, 0.85);
  font-weight: bold;
  text-align: center;
}

/* 内容区域：左二维码 右电话 */
.online-content {
  display: flex;
  align-items: center;
  gap: 30px;
}

/* 二维码 */
.qrcode-box {
  flex-shrink: 0;
  width: 200px;
  height: 200px;
  padding: 8px;
  background-color: #ffffff;
  border: 1px solid #ebeef5;
  border-radius: 10px;
  box-shadow: 0 0 10px #ebecec;
  display: flex;
  align-items: center;
  justify-content: center;
}

.qrcode-box .qrcode {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

/* 右侧：电话信息 + 关闭按钮 */
.right-box {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 20px;
}

/* 咨询电话 */
.phone-box {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
}

.phone-box .phone-row {
  display: flex;
  align-items: center;
}

.phone-box .phone-label {
  font-size: 15px;
  color: #333333;
  white-space: nowrap;
}

.phone-box .phone-number {
  font-size: 15px;
  font-weight: 600;
  color: #333333;
  letter-spacing: 1px;
  white-space: nowrap;
}

/* 关闭按钮：蓝色边框 + 蓝色字体 */
.btn-box {
  flex-shrink: 0;
}

.btn-close {
  color: #409EFF;
  border-color: #409EFF;
  background-color: #ffffff;
}

.btn-close:hover,
.btn-close:focus {
  color: #66b1ff;
  border-color: #66b1ff;
  background-color: #ecf5ff;
}

/* 适配移动端 */
@media (max-width: 768px) {
  .el-dialog {
    width: 90% !important;
  }

  .online-content {
    flex-direction: column;
  }

  .right-box {
    flex-direction: column;
  }

  .phone-box {
    align-items: center;
  }
}
</style>
